import {Log} from '@aboutyou/mlm';
import {IconsCache} from 'react-lazy-svg';

export const loadClientIconSVGLoader =
  ({
    iconsCache,
    assetsUrl,
  }: {
    iconsCache: IconsCache;
    assetsUrl: string | undefined;
  }) =>
  async (url: string) => {
    const cacheKey =
      assetsUrl && url.startsWith(assetsUrl) ? new URL(url).pathname : url;

    /**
     * In production mode, the svgs are requested with the full path (e.g. https://assets.aboutstatic.com/assets/icon-x.svg).
     * But the icons cache store the icons with their relative path (e.g. /assets/icon-x.svg) as the key.
     * So we need to check if the icon is already in the cache with the relative path.
     * If we do have it, we return the cached icon
     */
    if (iconsCache.has(cacheKey)) {
      const iconData = await iconsCache.get(cacheKey);

      const svgString = iconData?.svgString.__html;
      const {id: _id, ...rawAttributes} = iconData?.attributes ?? {};

      /**
       * If we have the icon in the cache, we need to return it as a string.
       * The svgString is already sanitized, but its just the svg body.
       * We need to wrap it in a svg tag and add the attributes to it.
       */
      if (svgString) {
        const svgAttributesString = Object.entries(rawAttributes)
          .reduce((acc, [key, value]) => {
            return `${acc} ${key}="${value}"`;
          }, '')
          .trim();

        return `<svg ${svgAttributesString}>${svgString}</svg>`;
      }
    }

    const resolvedUrl =
      url.startsWith('/') && assetsUrl ? `${assetsUrl}${url}` : url;
    try {
      const res = await window.fetch(resolvedUrl);
      // do not log to monitoring for canceled requests
      if (res.status === 0) {
        return undefined;
      }
      return await res.text();
    } catch (error) {
      if (error?.code === 'ECONNABORTED') {
        // do not log to monitoring for timeouts
        return undefined;
      }

      Log.error('@aboutyou/bootstrap', `could not load icon from ${url}`, {
        error,
      });

      return undefined;
    }
  };
